import React from 'react';
import AuthenticatedPage from "../ContextAndHOC/AuthenticatedPage";
import { withStyles, Button, withWidth } from '@material-ui/core';
import PropTypes from 'prop-types';
import ErrorDialogsuccess from '../components/ErrorDialog';
import SuccessDialog from '../components/SuccessDialog';
import JsonPreview from '../Views/PreviewTrivia';
import CircularProgress from '@material-ui/core/CircularProgress';
import CommonDashboard from '../components/CommonDashBord';
import {StatusCodes} from 'http-status-codes';
import Title from '../components/CommonDashboardTitle';
import {buildData, handleError} from "../components/DeleteRecurring";
const styles = theme => ({
    root: {marginTop: theme.spacing(3),...theme.mixins.gutters(),paddingTop: theme.spacing(1),paddingBottom: theme.spacing(1),},
    tableStyle: {maxWidth: "1200px", margin: '0px auto', padding: "0",[theme.breakpoints.down("sm")]: {margin: 0 }},
    primaryBtn: { color: theme.palette.text.textPrimaryColor, backgroundColor: theme.palette.primary.main,
border: `1px solid${theme.palette.border.primaryBorder}`, borderRadius: "50px", margin: "8px 0", textAlign: "right", padding: "7px 20px",
textTransform: "uppercase", '&:hover': { backgroundColor: theme.palette.hoverPrimaryColor.main, color: theme.palette.text.hoverTextPrimaryColor,
border: `1px solid ${theme.palette.border.hoverPrimaryBorder}`, } },
    loadingBody:{minHeight:'100vh'},
});

class ArticleList extends React.Component {
    state = {
         Triviadata:[] ,
        inactivate: false,
        totalTrivia: '',
        loading: true,
        TriviaListCount: 0,
        deleteTriviaId:'',
        reqAttentionCount:0,
        reqAttentionFilter:"1",
        Open:false,
        id:0,
        openpopup:false,
        previewopen:true,
        values:{},
        dialogueLoad: false,
        deleteDialogStatus:false,
        deleteMessage:"",
        version:null
    };
    handleTriviaEditUser = (resourceid, variant,version, clone,newversion_clone) => {
    const selectedarticle = this.state.Triviadata.filter((n) => n.resourceid === resourceid);
    const versioneditarticle=selectedarticle.filter((n) =>n.versionNumber === version);
    if(!clone){
        this.props.history.push({
            pathname: `./Trivia/Edit/${resourceid}/${variant}`,
            clone,newversion_clone,
            state: { detail:versioneditarticle }
          });
    } else {
        this.props.history.push({
            pathname: `./Trivia/Edit/Clone/${resourceid}/${variant}`,
            clone,newversion_clone,
            state: { detail:versioneditarticle }
          });
    }
    };
     handleTriviadeletepopup= async (resourceid, version)=>{

        this.setState({Open:true,id:resourceid, version});
};
  handleDeleteUsertrivia = async() => {
        this.setState({dialogueLoad:true, Open:false})
        let response = await this.props.authenticatedApiCall('post', '/api/content/contentservice/deleteTriviaResource', buildData(this.state.Triviadata, this.state.id, this.state.version));
        this.setState({dialogueLoad:false, deleteDialogStatus:true});
        const ErrorMsg = handleError(response);
        this.setState({deleteMessage: ErrorMsg});
  };
    handleCloseDialogtrivia = () => {
        this.setState({Open:false});
    };
    handletriviapreview=(resourceid,version)=>{
    const selectedtrvia = this.state.Triviadata.filter((n) =>n.resourceid === resourceid);
    const triviapreviewdata=selectedtrvia.filter((n) =>n.versionNumber === version);
    this.setState({values:triviapreviewdata[0],openpopup:true,previewopen:true});
    };
    async componentDidMount() {
        let response = await this.props.authenticatedApiCall('get', '/api/content/contentservice/getTriviaResource', null);
        if (response && response.status === StatusCodes.OK) {
            this.setState({totalTrivia:response.data.data.length,TriviaListCount:response.data.data.length});
            this.setState({ Triviadata:response.data.data });
        } else {
            this.setState({Triviadata: []});
        }
    }
   handleAddNewTrivia = () => {
      this.props.history.push("./Trivia/New");
    };
 handleClose = () => {
     this.setState({openpopup:false,previewopen:false});
  };
  handleDeleteDialogClose = () => {
    this.props.history.go(0);
  }
    render() {
        const { classes} = this.props;
            const okbutton = [
      <Button className={classes.primaryBtn} onClick={this.handleCloseDialogtrivia} >No</Button>,
      <Button className={classes.primaryBtn} onClick={this.handleDeleteUsertrivia}>Yes</Button>
    ];
    const deleteDialogButton = [ <Button className={classes.primaryBtn} onClick={this.handleDeleteDialogClose}>Close</Button> ];
    const errorMessage = "Are you sure you want to delete this Trivia?";
        return (
            <div>
                <div className={classes.tableStyle}>
                 <Title titlename={"Trivia"} count={this.state.totalTrivia}  button3={this.handleAddNewTrivia}/>
                    {(this.state.totalTrivia==="" && this.state.loading) && <div className={classes.loadingBody}>
                    <CircularProgress color="primary" style={{position: "absolute",left: "50%",top:"50%"}}/></div>}
                    {this.state.Triviadata && this.state.Triviadata.length>0? <CommonDashboard  patientList = {this.state.Triviadata}
                    reqAttentionFilter={this.state.reqAttentionFilter} handleEditUser={this.handleTriviaEditUser}  handleDeleteUser={this.handleTriviadeletepopup}
                    handleAddNewPatient={this.handleAddNewTrivia} name={"trivia"} handlepreview={this.handletriviapreview} />:""}
                </div>
                {this.state.Open? <ErrorDialogsuccess successButton={okbutton}  HeaderText={errorMessage}  dismiss={this.handleCloseDialogtrivia}/>:""}
                {this.state.deleteDialogStatus && <SuccessDialog successButton={deleteDialogButton} HeaderText={"Success"} BodyText={this.state.deleteMessage}  dismiss={this.handleDeleteDialogClose}/>}
                {this.state.dialogueLoad && <div className={classes.loadingBody}> <CircularProgress color="primary" style={{position: "absolute",left: "50%",top:"75%"}}/></div>}
                {this.state.openpopup ? (<JsonPreview open={this.state.previewopen} handleClose={this.handleClose}
                list={this.state.values} /> ) : ( "" )}
            </div>
        );
    }
}
ArticleList.propTypes = {
    classes: PropTypes.object.isRequired,
};
export default withWidth()((withStyles(styles)(AuthenticatedPage()(ArticleList))));